
export enum INTERACTION_TYPE {
  ANALYSIS = "ANALYSIS",
  DEAL_CHAT = "DEAL_CHAT",
  REGULAR_CHAT = "REGULAR_CHAT",
  TOOL_CHAT = "TOOL_CHAT"
}

export enum AI_TOOL {
  APPLY_WORKBOOK_PATCH = "apply_workbook_patch",
  GET_DATASET_META = "get_dataset_metadata",
  READ_RANGE = "read_range",
  WRITE_RANGE = "write_range",
  EXECUTE_JS = "execute_js",
  WEB_SEARCH = "web_search",
  DOWNLOAD_FILE = "download_file",
  GET_WORKBOOK_FILE = "get_workbook_file",
  SUBMIT_ANALYSIS_RESULT = "submit_analysis_result"
}

